import React from 'react';
import Checkbox from 'antd/lib/checkbox';
import classNames from 'classnames';

import { additionsClasses } from '../../../utils';

import style from './Checkbox.module.scss';

export const SingleCheckBox = ({ additions = [ 'column' ], children, ...props }) => (
  <div className={ classNames(style.wrapper, additionsClasses(additions, style)) }>
    <Checkbox className={ style.checkbox } { ...props }>
      {children}
    </Checkbox>
  </div>
);

